/**
 * function to set formatNumber based on this project standard
 * @param number
 * @returns {string}
 */
export const formatNumber = (number) =>{
    return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
    });
};